<onyx-modal
  variant="center"
  [heading]="`${I18N}.otherReason`"
  [size]="480"
  [close$]="close$"
  (closeModal)="dialogRef.close($event)"
>
  <div [onyxAutoFocus]="true">
    <onyx-textarea
      [formControl]="reason"
      [placeholder]="`${I18N}.rejectReason`"
    ></onyx-textarea>
  </div>

  <ng-container bottomRightOptions>
    <onyx-button variant="outlined" (click)="close$.next(false)">
      {{ 'labels.cancel' | translate }}
    </onyx-button>

    <onyx-button [spinner]="loading()" (click)="!loading() ? submit() : null">
      {{ 'labels.save' | translate }}
    </onyx-button>
  </ng-container>
</onyx-modal>
